import { Box } from '@mui/material'
import React from 'react'

import { card } from '@/styles/MuiComponentStyles'

type Props = {
  children?: React.ReactNode
}

export default function Card({ children }: Readonly<Props>) {
  return (
    <Box sx={card} data-testid="card">
      {children}
    </Box>
  )
}
